import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";


import { Bar } from "react-chartjs-2";
import { GetBenchsaalesStats } from "../apiconstants/constants";
import LoadingSpinner from "../helpers/loadingspinner";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useCountry } from "../contexts/countrycodecontext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // ✅ add
);
const BenchSalesBarGraph = ({ dateFilter }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDateFilter, setSelectedDateFilter] = useState({
  value: "Past 30 days",
  label: "Past 30 days",
});


  const token = localStorage.getItem("jwtToken");
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");

  const Guid = roleID == 3 ? employerGuid : guid;
  const { selectedCountry } = useCountry(); 

 

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const res = await axios.get(GetBenchsaalesStats.APIURL, {
          params: {
            guid: Guid,
            DateFilter: dateFilter,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(res.data || []);
      } catch (err) {
        console.error("Error fetching bench sales stats", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [Guid, dateFilter, selectedCountry, token]);

  // ✅ Aggregate totals
  const totals = data.reduce(
    (acc, curr) => {
      acc.overall += curr.submittedCount || 0;
      acc.new += curr.newCount || 0;
      acc.submitted += curr.submittedStatusCount || 0;
      acc.inProgress += curr.inProgressCount || 0;
      acc.interviews += curr.interviewScheduledCount || 0;
      acc.rejected += curr.rejectedCount || 0;
      acc.onHold += curr.onHoldCount || 0;
      return acc;
    },
    {
      overall: 0,
      new: 0,
      submitted: 0,
      inProgress: 0,
      interviews: 0,
      rejected: 0,
      onHold: 0,
    }
  );

 const chartData = {
  labels: ["Status"],
  datasets: [
    {
      label: "Overall",
      data: [totals.overall],
      backgroundColor: "#00a7ac",
      borderRadius: 6,
    },
    {
      label: "New",
      data: [totals.new],
      backgroundColor: "#6c757d",
      borderRadius: 6,
    },
    {
      label: "Job Submissions",
      data: [totals.submitted],
      backgroundColor: "#007bff",
      borderRadius: 6,
    },
    {
      label: "In-progress",
      data: [totals.inProgress],
      backgroundColor: "#ffc107",
      borderRadius: 6,
    },
    {
      label: "Interviews Scheduled",
      data: [totals.interviews],
      backgroundColor: "#960cb2ff",
      borderRadius: 6,
    },
    {
      label: "Rejected",
      data: [totals.rejected],
      backgroundColor: "#dc3545",
      borderRadius: 6,
    },
    {
      label: "On Hold",
      data: [totals.onHold],
      backgroundColor: "#343a40",
      borderRadius: 6,
    },
  ],
};


const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true, // ✅ show legend
      position: "bottom",
      labels: {
        boxWidth: 14,
        font: { size: 12 },
      },
    },
    title: {
      display: true,
      
      color: "#00a7ac",
      font: { size: 16 },
      marginBottom:20,
    },
    datalabels: {
      anchor: "end",
      align: "top",
      color: "#000",
      font: {
        size: 12,
        weight: "bold",
      },
      formatter: (value) => value, // ✅ show value
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0, // no decimals
      },
    },
  },
};


  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
         
        }}
      >
        <h5 style={{ color: "#00a7ac", margin: 0 }}>
          Bench Sales Statistics
        </h5>

         </div>

      {/* Chart */}
      {loading ? (
        <center>
          <LoadingSpinner />
        </center>
      ) : (
        <Bar data={chartData} options={chartOptions} />
      )}
    </div>
  );
};

export default BenchSalesBarGraph;
